module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', [_c('Announcement', {
    attrs: {
      "props": _vm.props.acf.announcement
    }
  }), _c('HomeHero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('Welcome', {
    attrs: {
      "props": _vm.props.acf.welcome
    }
  }), _c('Testimonials', {
    attrs: {
      "props": _vm.props.acf.testimonials
    }
  }), _c('Social', {
    attrs: {
      "props": _vm.props.acf.social
    }
  }), _c('Contact')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a64dcc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 708
// module chunks = 1